<template>
    <b-modal
        id="defectmodal"
        :title="formModal.title"
        @hidden="resetModal"
        size="lg"
        ok-only
    >
        <div class="d-flex justify-content-between align-items-center mb-3">
            <house-component-defect-form :is-edit="false" :modal-id="0" :component-id="component_id" :group-id="group_id" @update-list="updateList"></house-component-defect-form>
        </div>

        <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="defect in defects" :key="defect.id">
                <span>
                    {{ defect.label }}
                    <span v-if="defect.context_helper" class="d-block text-muted small">{{ defect.context_helper }}</span>
                </span>
                <span class="pull-right d-flex align-items-center">
                    <a v-if="defect.sample_image_url" class="btn btn-info btn-sm btn-circle mr-1" @click="viewSampleImage(defect)" title="Sample Image">
                        <i class="fa fa-image"></i>
                    </a>
                    <house-component-defect-form :is-edit="true" :form-data="defect" :component-id="component_id" :group-id="group_id" @update-list="updateList" :modal-id="defect.id"></house-component-defect-form>
                    <a class="btn btn-danger btn-sm btn-circle ml-1" @click="deleteThis(defect.id)">
                        <i class="fa fa-trash"></i>
                    </a>
                </span>
            </b-list-group-item>
        </b-list-group>

        <image-lightbox ref="lightbox" />
    </b-modal>
</template>

<script>
export default {
    data(){
        return this.initData();
    },
    methods: {
        initData(){
            return {
                formModal: {
                    title: null
                },
                defects: [],
                component_id: null,
                group_id: null,
            }
        },
        async openModal(componentId, groupId, componentName, groupName){
            try {
                const { data } = await axios.get(route("admin.houses.components.groups.defects.index", [componentId, groupId]));
                this.component_id = componentId;
                this.group_id = groupId;
                this.defects = data.data;
                this.formModal.title = [componentName, groupName].filter(Boolean).join(' > ') || 'Defect List';
                this.$bvModal.show('defectmodal');
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        async updateList(){
            try {
                const { data } = await axios.get(route("admin.houses.components.groups.defects.index", [this.component_id, this.group_id]));
                this.defects = data.data;
                this.$emit('update-list');
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        resetModal(){
            this.defects = this.initData().defects;
        },
        viewSampleImage(defect){
            this.$refs.lightbox.open(defect.sample_image_url, {
                title: 'Sample: ' + defect.label,
                caption: defect.context_helper,
            });
        },
        async deleteThis(id){
             this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data } = await axios.delete(route("admin.houses.components.groups.defects.destroy", [this.component_id, this.group_id, id] ));
                        this.$swal({
                            title: 'Deleted!',
                            text: 'House Component Defect has been deleted.',
                            icon: 'success',
                            didClose: () =>{
                                this.updateList();
                            }
                        })
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        }
    }
}

</script>
